import React from 'react';

import { nanoid } from '@reduxjs/toolkit';
import { useTranslation } from 'react-i18next';

import { bemCssModules, getTestId } from '@utils';
import { useLocation } from '@utils/hooks';
import { FooterMenuLink } from '@utils/types';

import ZHDisclaimer from '@containers/ZHDisclaimer';

import LangSwitcher from './LangSwitcher';

import style from './Footer.scss';

const cn = bemCssModules(style, 'Footer');
const ti = getTestId('Footer');

export type TLink = {
  link: FooterMenuLink['link'];
  text: FooterMenuLink['text'];
  onClick?(): void;
};

const Link: CustomFC<TLink> = ({ link, text, onClick }) => {
  const { t } = useTranslation();
  const currentHref =
    link !== '/help'
      ? `https://mercuryo.io${link}?utm_source=my.mercuryo&utm_medium=referral`
      : 'https://help.mercuryo.io/hc/en-gb/sections/14494982716829-Getting-started-';

  const dataTestId = link.slice(1);

  return (
    <a
      onClick={onClick}
      data-testid={ti(`${dataTestId}-link`)}
      className="link"
      href={currentHref}
      rel="noreferrer"
      target="_blank"
    >
      {t(text)}
    </a>
  );
};

const Footer: CustomFC = ({ className }) => {
  const { pathname } = useLocation();

  const isMatchLoginPage = pathname === CONST.nav.loginEmail;

  return (
    <footer className={cn(null, [className])}>
      <div className={cn('wrapper')}>
        <div className={cn('links', { isHidden: !isMatchLoginPage })}>
          {CONST.infoLinks.map(({ link, text }) => (
            <Link key={nanoid()} link={link} text={text} />
          ))}
          <LangSwitcher />
        </div>
        <ZHDisclaimer className={cn('disclaimer')} />
      </div>
    </footer>
  );
};

export default Footer;
